import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/common.css';

const VendorSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="container">
      <h1 className="title">申請完了</h1>

      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <p style={{ fontSize: '16px' }}>
          確認メールを送信しましたので、ご確認ください。<br />
        </p>
        <p style={{ fontSize: '14px', color: '#666' }}>
          なお、数分経過してもメールが届かない場合は<br />
          お手数ですがご連絡くださいますようお願いいたします。
        </p>

        <button className="button button-purple button-fixed" style={{ marginTop: '30px' }} onClick={() => navigate('/license')}>
          ホームへ
        </button>
      </div>
    </div>
  );
};

export default VendorSuccess;
